declare global {
  interface Window {
    clarity?: (command: string, ...args: unknown[]) => void;
  }
}

const CLARITY_PROJECT_ID = 'wi8gk3rii6';

class MicrosoftClarity {
  private static instance: MicrosoftClarity;
  private initialized: boolean = false;

  static getInstance(): MicrosoftClarity {
    if (!MicrosoftClarity.instance) {
      MicrosoftClarity.instance = new MicrosoftClarity();
    }
    return MicrosoftClarity.instance;
  }

  init(): void {
    if (this.initialized || !window.clarity) return;
    this.initialized = true;
  }

  private call(command: string, ...args: unknown[]): void {
    if (typeof window.clarity === 'function') {
      window.clarity(command, ...args);
    }
  }

  identify(userId: string, sessionId?: string, pageId?: string, friendlyName?: string): void {
    this.call('identify', userId, sessionId, pageId, friendlyName);
  }

  setTag(key: string, value: string | string[]): void {
    this.call('set', key, value);
  }

  event(name: string): void {
    this.call('event', name);
  }

  upgrade(reason: string): void {
    this.call('upgrade', reason);
  }

  get projectId(): string {
    return CLARITY_PROJECT_ID;
  }
}

export const clarity = MicrosoftClarity.getInstance();
